import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { useAppMessage } from "@repo/ui";
import { marketingCabinetRegisterApi } from "@src/api";
import type {
    ErrorResponseType,
    MarketingCabinetCreateType,
    ResponseWithMessage,
} from "@src/types";

export function useMarketingCabinetRegister() {
    const message = useAppMessage();
    const queryClient = useQueryClient();

    return useMutation<
        ResponseWithMessage,
        AxiosError<ErrorResponseType>,
        MarketingCabinetCreateType
    >({
        mutationKey: ["marketing-cabinet", "register"],
        mutationFn: (payload) => marketingCabinetRegisterApi(payload),
        onSuccess(data) {
            message.success(data.detail ?? "Маркетинговый кабинет успешно добавлен!");
        },
        onError(err) {
            message.error(err.response?.data?.detail ?? "Произошла непредвиденная ошибка!");
        },
        onSettled: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: ["marketing-cabinets"] }),
                queryClient.invalidateQueries({ queryKey: ["marketing-merchants"] }),
                queryClient.invalidateQueries({ queryKey: ["user-detailed-merchants"] }),
            ]);
        },
    });
}
